import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SharedModule } from '@/app/shared/shared.module';
import { CropHealthService } from '../../../../services/crop-health.service';
import { DialogService } from 'primeng/dynamicdialog';
import { TranslateService } from '@ngx-translate/core';
import { PurchasePremiumComponent } from '@/app/features/shared/components/purchase-premium/purchase-premium.component';

export enum MapMessageTypeEnum {
  imagePreparing = 'image-preparing',
  problematicSpot = 'problemetic-spot',
  cloudyWeather = 'cloudy-wather',
  noProblem = 'no-problem',
  loading = 'loading',
  outsidePlantationArea = 'outside-plantation-area',
  permiumRequired = 'premium-required',
}

@Component({
  selector: 'app-crop-health-map-message-overlay',
  imports: [SharedModule],
  templateUrl: './crop-health-map-message-overlay.component.html',
  styleUrl: './crop-health-map-message-overlay.component.less',
})
export class CropHealthMapMessageOverlayComponent implements OnInit {
  @Input() message: MapMessageTypeEnum;
  @Output() seeProblameticSpot = new EventEmitter();
  mapMessageTypeEnum = MapMessageTypeEnum;

  constructor(
    private cropHealthService: CropHealthService, 
    private dialogService: DialogService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.cropHealthService.mapOverlayMessage$.subscribe(message => {
      this.message = message;
    })
  }

  closeOverlay() {
    this.cropHealthService.setMapOverlayMessage(undefined)
  }

  goToPremium() {
    this.dialogService.open(PurchasePremiumComponent, {
      modal: true,
      closable: true,
      header: this.translateService.instant('doktar_app.services.crop_monitoring.psd_premium_title'),
      inputValues: {
        selectedfeatureKey: 'spot-detection'
      }
    })
  }
}
